// removed by extract-text-webpack-plugin
module.exports = {"flexContainer":"pVQHD","buttons":"_3nOti","button":"_1DQF9"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/text-editor-mobile-toolbar.scss
// module id = 724
// module chunks = 3 4 5 6 7